import moment from 'moment';

// eslint-disable-next-line func-names
(function () {
    function $dateExtender(date) {
        function modifyDateByTimePeriod() {
            const basic = moment(date).format('D MMM');
            const today = moment().startOf('day');
            const dayAgo = moment().subtract(1, 'days');
            const weekAgo = moment().subtract(7, 'days');
            const yearAgo = moment().subtract(1, 'years');

            const isInWeek = moment(date).isBetween(weekAgo, dayAgo);
            const isOlderThanYear = moment(date).isBefore(yearAgo);
            const isToday = moment(date).isSame(today, 'd');

            if (isToday) {
                return moment(date).format('HH:mm');
            }
            if (isInWeek) {
                return `${moment(date).format('ddd')}.`;
            }
            if (isOlderThanYear) {
                return moment(date).format('DD MMM YYYY');
            }
            return basic;
        }

        return { modifyDateByTimePeriod };
    }

    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Date.prototype, 'extensions', {
        set() {},
        get() {
            return $dateExtender(this);
        }
    });
}());